import { render, staticRenderFns } from "./AdminEmailConfig.vue?vue&type=template&id=66544edb&"
import script from "./AdminEmailConfig.vue?vue&type=script&lang=js&"
export * from "./AdminEmailConfig.vue?vue&type=script&lang=js&"
import style0 from "./AdminEmailConfig.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminEmailConfig.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports